
export function legacyMapSetContent(editor, e) {
  const $ = editor.dom.$
  $('[mapdata]', e.node).each((idx, elm) => {
    if (elm.contentEditable != 'false') {
      const $elm = $(elm)
      const keditorData = $elm.attr('data-maps-data')
      const data = $elm.attr('mapdata')

      if (data && !keditorData) {
        $elm.attr('data-maps-data', data)
      }
    }
  })
}
